<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card no-body class="mb-0">
    <p class="font-weight-bolder">Resident Feedback List</p>

    <b-table
      class="data-table"
      hover
      :items="feedback"
      :current-page="currentPage"
      :per-page="-1"
      :fields="headers">
      <template #cell(reason)="data">
        {{data.item.reason || 'No reason specified'}}
      </template>
    </b-table>

    <b-row class="p-1">
      <b-col md="6" class="m-1" v-if="totalRows > limit">
        <b-pagination :total-rows="totalRows" :per-page="limit" v-model="currentPage" class="my-0"/>
      </b-col>
      <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No Feedback available</p>
    </b-row>

  </b-card>
</template>
<!-- eslint-enable -->

<script>
  // import moment from 'moment';
  import { mapState } from 'vuex';
  import BiStatsService from '../../../services/BiStatsService';

  export default {
    components: {},
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        feedback: [],
        headers: [
          { label: 'Prison', key: 'prison' },
          { label: 'Rating', key: 'rating' },
          { label: 'Reason', key: 'reason' },
        ],
        limit: 10,
        currentPage: 1,
        perPage: 10,
        totalRows: 10,
        selectedFeedback: null,
      };
    },
    computed: {
      ...mapState({
       // filters: state => state.stats.filters,
        prisons: state => state.stats.prisons,
      }),
    },
    watch: {
      currentPage() {
        this.getFeedback();
      },
    },
    mounted() {
      this.getFeedback();
    },
    methods: {
      getFeedback() {
        const filters = {
          ...this.filters,
          limit: this.limit,
          sort: '-visit_date',
          skip: (this.currentPage - 1) * this.limit,
        }

        BiStatsService.getPrisonerFeedbackPaginated(filters).then(res => {
          this.totalRows = res.data.count;
          this.formatFeedback(res.data.data);
        }).catch(err => {
          console.log('error getting feedback paginationed', err);
          this.$toast.error('Could not get feedback details, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      formatFeedback(feedback) {
        this.feedback = [];

        feedback.forEach(item => {
          const prison = this.getPrisonNameFromId(item.prison_id);
          this.feedback.push({
            prison: prison ? prison.name : '-',
            ...item,
          });
        });
      },
      getPrisonNameFromId(prisonId) {
        return this.prisons.find(prison => prison.prison_id === prisonId);
      },
    },
  };
</script>
